import React, { useContext } from "react";

import { Button, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMessage } from "@hookform/error-message";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import NotyfContext from "contexts/NotyfContext";
import { LoadingContext } from "App";
import * as authApi from "@api/authApi";

const schema = yup.object().shape({
    email: yup
        .string()
        .email("Must be a valid email address")
        .required("This field is required"),
});

const ForgotPasswordForm = () => {
    // eslint-disable-next-line
    const [isLoadingActive, setIsLoadingActive] = useContext(LoadingContext);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        mode: "onTouched",
        resolver: yupResolver(schema),
    });
    const notyf = useContext(NotyfContext);
    const navigate = useNavigate();

    //
    // Functions
    //

    const signInHandler = async (data) => {
        try {
            setIsLoadingActive(true);
            const response = await authApi.forgotPassword(data);

            if (response.status === 200) {
                notyf.open({
                    type: "success",
                    message: response.data.message,
                });
                setIsLoadingActive(false);
            }
        } catch (error) {
            notyf.open({
                type: "danger",
                message: error?.message,
            });
            setIsLoadingActive(false);
        }
    };

    return (
        <Form>
            <Form.Group className="mb-1">
                <Form.Label>Email</Form.Label>
                <Controller
                    control={control}
                    name="email"
                    defaultValue=""
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Form.Control
                            size="lg"
                            type="text"
                            placeholder="Enter your email in lower case"
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            className={errors.email && "is-invalid"}
                        />
                    )}
                />
                <ErrorMessage
                    errors={errors}
                    name="email"
                    render={({ message }) => (
                        <small className="text-danger">{message}</small>
                    )}
                />
            </Form.Group>
            <Form.Group className="text-start">
                <Button
                    variant="link"
                    className="ps-0"
                    onClick={() => navigate("/auth/sign-in")}
                >
                    Back to sign in page
                </Button>
            </Form.Group>

            <div className="text-end">
                <Button
                    variant="primary"
                    size="lg"
                    onClick={handleSubmit(signInHandler)}
                >
                    Send password reset link
                </Button>
            </div>
        </Form>
    );
};

export default ForgotPasswordForm;
